import { makeStyles } from '@material-ui/core';
import logo from './logo-png.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 50,
  }
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      src={logo}
      alt="Logo"
      className={classes.img}
    />
  );
};

export default LogoFull;
